import React, { useRef } from "react";
import { ProfessionalConnectModal } from "./Modal";

export interface ProfessionalConnectProps {
  pcOptin: boolean;
  pcSlug: string;
}

export const ProfessionalConnect: React.FunctionComponent<ProfessionalConnectProps> = (props: ProfessionalConnectProps) => {
  const [isPc, setIsPc] = React.useState<boolean>();
  const modalRef = useRef();
  const openModal = (): void => {
    modalRef.current?.showModal();
  };
  React.useEffect(() => {
    setIsPc(props.pcOptin === true);
  }, []);
  return (
    <>
      <div className="professional-connect" onClick={openModal}>
        {isPc === true && (
          <>
            <div className="">
              <span className="icon-link me-1"></span>Open to Professional Connection&nbsp;&nbsp;
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                data-supported-dps="16x16"
                fill="currentColor"
                width="14"
                height="14"
                focusable="false"
              >
                <path d="M14.13 1.86a3 3 0 00-4.17 0l-7 7L1 15l6.19-2 6.94-7a3 3 0 000-4.16zm-8.36 9.71l-1.35-1.34L9.64 5 11 6.35z"></path>
              </svg>
            </div>
            <div>
              <a>See all details</a>
            </div>
          </>
        )}
        {isPc === false && (
          <>
            <div>
              <span className="icon-link me-1"></span>
              <span className="fw400">Professional Connect:</span> Share your offers and needs to other professionals.
            </div>
            <div>
              <a>Get started</a>
            </div>
          </>
        )}
      </div>
      <ProfessionalConnectModal ref={modalRef} pcSlug={props.pcSlug} cb={(isPc: boolean): void => setIsPc(isPc)} />
    </>
  );
};
